<template>
    <base-modal
        :title="modalTitle"
        size="lg"
        :confirm-text="btnDisabled ? 'Guardando...' : 'Guardar cambios'"
        :confirm-disabled="btnDisabled"
        @close="close"
        @confirm="handleSubmit"
    >
        <div class="row p-3">
            <div class="col-12 mb-3">
                <input type="checkbox" v-model="showFilters" id="toggleFilters">
                <label for="toggleFilters"><small> Mostrar filtros</small></label>
            </div>

            <div class="row pb-4" v-if="showFilters">
                <div class="col-md-4 py-1" v-for="(value, key) in filters" :key="key">
                    <small>{{ filterLabels[key] }}</small>
                    <input 
                        type="text" 
                        v-model="filters[key]" 
                        :placeholder="'Buscar ' + filterLabels[key]" 
                        class="form-control rounded-8 sin-borde"
                    >
                </div>
                <div class="col-md-12 py-2">
                    <button class="btn text-white bg-utel rounded-8 me-2" @click="applyFilters">Filtrar</button>
                    <button class="btn text-white bg-utel rounded-8" @click="clearFilters">Limpiar</button>
                </div>
            </div>
        </div>

        <v-data-table
            :headers="headers"
            :items="students"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            :server-items-length="totalItems"
            :loading="loading"
            v-model="selectedStudents"
            item-value="id"
            show-select
            class="elevation-1"
            hide-default-footer
        >
            <template v-slot:item.data-table-select="{ item, isSelected, select }">
                <input
                    type="checkbox"
                    class="form-check-input"
                    :checked="item.active || isSelected"
                    @change="select($event.target.checked)"
                    :disabled="item.active"
                    :title="item.active ? disabledCheckboxTitle : ''"
                />
            </template>

            <template v-slot:item.created_at_convert_complete="{ item }">
                {{ item.created_at_convert_complete }}
            </template>

            <template v-slot:footer>
                <div class="text-center pt-2">
                    <v-pagination 
                        v-model="options.page"
                        :length="options.pageCount"
                        :total-visible="6" 
                        next-icon="fas fa-angle-right"
                        prev-icon="fas fa-angle-left"
                    ></v-pagination>
                </div>
            </template>
        </v-data-table>
    </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue';

export default {
    name: 'ModalManageRouteUsers',
    components: { BaseModal },
    props: {
        route: { type: Object, required: true },
        urlstudents: { type: String, required: true },
        mode: { type: String, default: 'add', validator: v => ['add', 'remove'].includes(v) }
    },
    data() {
        return {
            students: [],
            totalItems: 0,
            loading: false,
            options: {
                page: 1,
                pageCount: 0,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            selectedStudents: [],
            btnDisabled: false,
            showFilters: false,
            filters: { 
                firstname: '', 
                lastname: '', 
                email: '', 
                position: '', 
                area: '', 
                fecha: '' 
            },
            filterLabels: {
                firstname: 'Nombres',
                lastname: 'Apellidos',
                email: 'Correo',
                position: 'Cargo',
                area: 'Área',
                fecha: 'Fecha'
            },
            headers: [
                { text: 'Nombres', value: 'firstname' },
                { text: 'Apellidos', value: 'lastname' },
                { text: 'Correo', value: 'email' },
                { text: 'Cargo', value: 'position' },
                { text: 'Área', value: 'area' },
                { text: 'Fecha de creación', value: 'created_at_convert_complete' },
            ],
        };
    },
    computed: {
        modalTitle() {
            return this.mode === 'add' ? 'Agregar usuarios a ruta' : 'Remover usuarios de ruta';
        },
        disabledCheckboxTitle() {
            return this.mode === 'add' ? 'Este usuario ya está en la ruta' : '';
        },
        apiEndpoint() {
            return this.mode === 'add' 
                ? '/dashboard/routes/save-users-route' 
                : '/dashboard/routes/remove-users-route';
        }
    },
    watch: {
        options: {
            handler() {
                this.getUsers();
            },
            deep: true,
        }
    },
    mounted() {
        this.getUsers();
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async getUsers() {
            this.loading = true;

            let url = `${this.urlstudents}?withUsers=true&onlyClient=true`;
            url += `&idClientSelect=${this.route.client_id}&routeSelect=${this.route.id}`;
            
            if (this.mode === 'add') {
                url += '&userExist=true';
            } else {
                url += '&tipo=remove';
            }

            Object.keys(this.filters).forEach(key => {
                if (this.filters[key]) {
                    url += `&${key}=${this.filters[key]}`;
                }
            });

            url += `&page=${this.options.page}&per_page=${this.options.itemsPerPage}`;

            try {
                const { data } = await axios.get(url);
                this.students = data.data;
                this.totalItems = data.total;
                this.options.page = data.current_page;
                this.options.pageCount = data.last_page;
            } catch (error) {
                console.error('Error al cargar usuarios:', error);
            } finally {
                this.loading = false;
            }
        },
        async handleSubmit() {
            this.btnDisabled = true;

            const students = this.selectedStudents.map(s => (typeof s === 'object' ? s.id : s));
            const data = { students, idRoute: this.route.id };

            try {
                const { data: response } = await axios.post(this.apiEndpoint, data);
                
                this.close();
                
                await this.$nextTick();
                
                await this.$swal({
                    icon: 'success',
                    title: 'Éxito',
                    text: response.message || 'Cambios guardados correctamente',
                    confirmButtonText: 'Aceptar'
                });
                
                this.$emit('reloadtable');
            } catch (error) {
                console.error('Error al guardar:', error);
                
                this.close();
                
                await this.$nextTick();
                
                await this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'No se pudieron guardar los cambios',
                    confirmButtonText: 'Aceptar'
                });
            }
        },
        applyFilters() {
            this.options.page = 1;
            this.getUsers();
        },
        clearFilters() {
            Object.keys(this.filters).forEach(k => this.filters[k] = '');
            this.selectedStudents = [];
            this.options.page = 1;
            this.options.pageCount = 0;
            this.getUsers();
        }
    }
};
</script>
